/**
 * documentLastModifiedDateReducer.js
 * Created by Narayan on 12/12/2022.
 */

import initialState from './initialstate';
import * as types from '../actions/actiontypes';
import {cloneDeep} from 'lodash';

export function documentLastModifiedDateReducer(state = initialState.documentsLastModifiedInformation, action) {
	switch (action.type) {
		case types.UPDATE_DOCUMENT_LAST_MODIFIED_DATE: {
			let data = [...cloneDeep(state)];
			let dataObj = data.find((doc) => doc.documentId === action.documentId);
			if (dataObj) {
				dataObj.modifiedDate = action.modifiedDate ? action.modifiedDate : dataObj.modifiedDate;
				dataObj.showAlert = action.showAlert;
				dataObj.lastModifiedByFullName = action.lastModifiedByFullName;
			} else {
				return [
					...state,
					{
						documentId: action.documentId,
						modifiedDate: action.modifiedDate,
						showAlert: action.showAlert,
						lastModifiedByFullName: action.lastModifiedByFullName
					}
				];
			}
			return data;
		}
		default:
			return state;
	}
}
